import React from 'react'
import { Box, Typography } from '@telus-uds/components-web'
import { LegalTextRenderer } from '../../../utils/text/TextRenderer'

export type StickyCartHeaderProps = {
  componentHeader?: string
  heroImage?: React.ReactNode
}

const StickyCartHeader = ({ heroImage, componentHeader }: StickyCartHeaderProps) => {
  return (
    <>
      <Box vertical={4} horizontal={3}>
        <div style={{ paddingBottom: 32 }}>
          <Typography block variant={{ size: 'h1' }} heading="h1">
            <LegalTextRenderer>{componentHeader}</LegalTextRenderer>
          </Typography>
        </div>
        {heroImage}
      </Box>
    </>
  )
}

export default StickyCartHeader
